import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { getPlanTimeLeft } from 'utils/planTimeLeft';

import { ReactComponent as BillingIcon } from "assets/icons/new/Profile/Balance.svg";
import { ReactComponent as CardIcon } from "assets/icons/new/UI/Card.svg";
import { ReactComponent as DiscountIcon } from "assets/icons/new/Profile/Discount.svg";
import { ComponentsLoader } from 'components';
import type { IUserInfoPlan, IUserInfoBalance } from "redux/users/types";

interface IBillingStateistic extends IUserInfoPlan, IUserInfoBalance { sidebarOpen: boolean }

const BillingStatistic: React.FC<IBillingStateistic> = ({ plan, balance, sidebarOpen }) => {
    const { t } = useTranslation();
    const isPlanExpired = !!plan?.expiresDate && plan.daysLeft === 0;
    const planDesc = plan ?
        `${t(plan.id)} ${plan.id !== "Free" && isPlanExpired ? t("Expiress") : ""}`.trim()
        :
        t("Plan not set")
    const timeLeft = getPlanTimeLeft(plan?.daysLeft)

    return (
        <div className={`flex h-[50px] items-center lg:px-[9px] py-[7px] relative gap-x-3 text-[11px] hover:text-theme-hover dark:hover:text-theme-hover`}>
            <Link to="/billing" className='flex cursor-pointer shrink-0'>
                <BillingIcon width="20" height="20" fill="currentColor" />
            </Link>
            <div
                className={`transition-all duration-300 ${sidebarOpen ? 'min-w-[150px] opacity-100' : 'w-0 opacity-0 hidden'}`}
            >
                {
                    balance ?
                        <>
                            <div className='grid grid-cols-[50px_1fr]'>
                                <span>{t("plan")}:</span>
                                <span className='overflow-hidden text-ellipsis whitespace-nowrap' title={planDesc}>
                                    {planDesc}
                                </span>
                            </div>
                            {timeLeft && (
                                <div className='grid grid-cols-[50px_1fr]'>
                                    <span>{t('Active')}:</span>
                                    <span className='overflow-hidden text-ellipsis whitespace-nowrap'>
                                        {t(`plan_${timeLeft.unit}s_left`, { count: timeLeft.count })}
                                    </span>
                                </div>
                            )}
                            <Link to="/billing" className='grid grid-cols-[50px_1fr]'>
                                <span>{t("bank")}:</span>
                                <span className='flex items-center gap-x-1 overflow-hidden text-ellipsis whitespace-nowrap'>{balance.planAccount && balance.planAccount / 100} <CardIcon width="15" height="15" fill="currentColor" /> + {balance.serviceAccount && balance.serviceAccount / 100} <DiscountIcon width="15" height="15" fill="currentColor" /></span>
                            </Link>
                        </>
                        :
                        <div>
                            <ComponentsLoader size={16} />
                        </div>
                }
            </div>
        </div>
    )
}

export default BillingStatistic